const STRIPE_ZERO_DECIMAL_CURRENCIES = [
    'BIF',
    'CLP',
    'DJF',
    'GNF',
    'JPY',
    'KMF',
    'KRW',
    'MGA',
    'PYG',
    'RWF',
    'UGX',
    'VND',
    'VUV',
    'XAF',
    'XOF',
    'XPF',
];

export function formatCurrency(
    amount: number,
    currency = 'USD',
    locale = 'en-US',
    fractionDigits = 2,
    compact = false
): string {
    if (STRIPE_ZERO_DECIMAL_CURRENCIES.includes(currency)) {
        fractionDigits = 0;
    }
    const options: Record<string, any> = {
        style: 'currency',
        currency,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    };

    if (compact) {
        options.notation = 'compact';
        options.compactDisplay = 'short';
    }

    return Intl.NumberFormat(locale, options).format(amount);
}

/**
 * Extracts just the currency symbol from a currency code.
 * Uses Intl.NumberFormat to get the formatted symbol and strips out digits.
 * Falls back to '$' if no currency is provided.
 */
export function getCurrencySymbol(currency = 'USD', locale = 'en-US'): string {
    return Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    })
        .format(0)
        .replace(/\d/g, '')
        .trim();
}
